import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InactivateMemberMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type InactivateMemberMutation = { __typename?: 'RootMutationType', inactivateMember?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const InactivateMemberDocument = gql`
    mutation inactivateMember($id: ID!) {
  inactivateMember(id: $id) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type InactivateMemberMutationFn = Apollo.MutationFunction<InactivateMemberMutation, InactivateMemberMutationVariables>;

/**
 * __useInactivateMemberMutation__
 *
 * To run a mutation, you first call `useInactivateMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateMemberMutation, { data, loading, error }] = useInactivateMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInactivateMemberMutation(baseOptions?: Apollo.MutationHookOptions<InactivateMemberMutation, InactivateMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateMemberMutation, InactivateMemberMutationVariables>(InactivateMemberDocument, options);
      }
export type InactivateMemberMutationHookResult = ReturnType<typeof useInactivateMemberMutation>;
export type InactivateMemberMutationResult = Apollo.MutationResult<InactivateMemberMutation>;
export type InactivateMemberMutationOptions = Apollo.BaseMutationOptions<InactivateMemberMutation, InactivateMemberMutationVariables>;